/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Wed Sep 20 2023
 **/

import styled from "@emotion/styled";
import { Column, Row, Typography, Image } from "@/frameworks/designStuff/components";

export const CardWrapper = styled(Column)<{ status?: "waiting" | "in-use" | "used"; isShare3D?: boolean }>`
	width: 216px;
	height: 200px;
	border: 2px solid
		${({ theme, isShare3D }) => (isShare3D ? theme.colors.accent_50_100 : theme.colors.neutral_20_100)};
	border-radius: 12px;
	background: ${({ theme, status, isShare3D }) => {
		if (isShare3D) {
			return theme.colors.accent_40_100;
		}
		switch (status) {
			case "waiting":
				return theme.colors.neutral_00_68;
			case "in-use":
				return theme.colors.accent_40_100;
			case "used":
				return theme.colors.neutral_20_100;
		}
	}};
	padding: 8px;
	gap: 8px;
	&:hover {
		border: 2px solid ${({ theme }) => theme.colors.accent_30_100};
	}
	&:focus {
		border: 4px solid ${({ theme }) => theme.colors.accent_60_100};
	}
`;

export const FileImage = styled(Column)<{ src?: string; isFileRecordFolder?: boolean }>`
	position: relative;
	width: 100%;
	height: 112.5px;
	border-radius: 8px;
	border: 1px solid
		${({ theme, isFileRecordFolder }) =>
			isFileRecordFolder ? theme.colors.secondary_80_15 : theme.colors.neutral_50_8};
	background: ${({ theme, isFileRecordFolder }) =>
		isFileRecordFolder ? theme.colors.deco13_10_100 : theme.colors.accent_10_100};
	background-image: url(${({ src }) => src});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	&:hover {
		opacity: 0.8;
		.action_buttons {
			display: flex;
		}
	}
`;

export const ActionButtonWrapper = styled(Row)`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	padding: 4px;
	border-radius: 24px;
	box-shadow:
		0px 4px 8px 0px rgba(0, 0, 0, 0.12),
		0px 0px 4px 0px rgba(0, 0, 0, 0.04);
	background: ${({ theme }) => theme.colors.neutral_00_100};
	display: none;
`;

export const FileInfoWrapper = styled(Row)`
	width: 100%;
	padding: 0 4px;
`;

export const FileName = styled(Typography)`
	text-align: start;
	width: 100%;
`;

export const LinkBadge = styled(Row)`
	position: absolute;
	right: 4px;
	top: 4px;
	padding: 7px;
	border-radius: 8px;
	background-color: ${({ theme }) => theme.colors.neutral_70_100};
`;

export const ExtensionBadge = styled(Row)`
	position: absolute;
	right: 4px;
	top: 4px;
`;

export const ExtensionShare3D = styled(Row)`
	position: absolute;
	right: 4px;
	bottom: 4px;
`;

export const LinkThumbnail = styled(Image)`
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: inherit;
`;
